export function formatNumber(
  number,
  minFractionDigits = 0,
  maxFractionDigits = 0,
) {
  // 检查是否为 NaN
  if (
    Number.isNaN(number) ||
    number === undefined ||
    !Number.isFinite(number)
  ) {
    return '-'
  }

  // 格式化数字
  const formattedNumber = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: minFractionDigits,
    maximumFractionDigits: maxFractionDigits,
  }).format(number)

  return formattedNumber.replace(/,/g, '')
}

export function formatUSD(
  number,
  minFractionDigits = 2,
  maxFractionDigits = 2,
) {
  // 检查是否为 NaN
  if (
    Number.isNaN(number) ||
    number === undefined ||
    !Number.isFinite(number)
  ) {
    return '-'
  }

  // 格式化百分比
  const formattedNumber = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: minFractionDigits,
    maximumFractionDigits: maxFractionDigits,
  }).format(number)
  return formattedNumber.replace(/,/g, '')
}

export function formatPercent(
  number,
  minFractionDigits = 0,
  maxFractionDigits = 2,
) {
  // 检查是否为 NaN
  if (
    Number.isNaN(number) ||
    number === undefined ||
    !Number.isFinite(number)
  ) {
    return '-'
  }

  // 使用 Intl.NumberFormat 格式化百分比
  return new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: minFractionDigits,
    maximumFractionDigits: maxFractionDigits,
  }).format(number)
}

// 便捷函数：保留2位小数
export const fmt = (n) => {
  if (n == null || !Number.isFinite(n)) return '-'
  return n.toFixed(2)
}

// 便捷函数：显示为 K 单位，保留2位
export const fmtK = (n) => {
  if (n == null || !Number.isFinite(n)) return '-'
  return `$${(n / 1000).toFixed(2)}k`
}

// 便捷函数：百分比，保留2位
export const fmtPct = (n) => {
  if (n == null || !Number.isFinite(n)) return '-'
  return `${n.toFixed(2)}%`
}

// 便捷函数：金额，带千分位，保留2位小数
export const fmtMoney = (n) => {
  if (n == null || !Number.isFinite(n)) return '-'
  return `$${n.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`
}

export function formatMultiplier(
  number,
  minFractionDigits = 2,
  maxFractionDigits = 2,
  showSuffix = false,
) {
  // 检查是否为 NaN
  if (
    Number.isNaN(number) ||
    number === undefined ||
    !Number.isFinite(number)
  ) {
    return '-'
  }

  // 格式化数字
  const formattedNumber = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: minFractionDigits,
    maximumFractionDigits: maxFractionDigits,
  }).format(number)

  return showSuffix ? `${formattedNumber}x` : formattedNumber
}
